import {GOOGLE_ANALYTICS_ID} from '../config/config';

// Define gtag type for better type safety
interface GtagFunction {
    (command: 'event', eventName: string, eventParams?: Record<string, unknown>): void;
    (command: 'config', targetId: string, config?: Record<string, unknown>): void;
}

declare global {
    interface Window {
        gtag?: GtagFunction;
    }
}

export function logGoogleEvent(
    eventName: string,
    contentId: string | number,
    sourceTypeId: string,
    params?: Record<string, unknown>
): void {
    if(typeof window === 'undefined' || typeof window.gtag !== 'function') {
        return;
    }
    const payload: Record<string, unknown> = {
        page_path: window.location.pathname,
        page_location: window.location.href,
        ...(params ?? {}),
        content_id: String(contentId),
        source_type_id: String(sourceTypeId)
    };
    window.gtag('event', eventName, payload);
}

export const updateAnalyticsUserId = (userId: string | null) => {
    if(typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('config', GOOGLE_ANALYTICS_ID, {
            global_user_id: userId
        });
    }
};
